import { getNoteGenerationEngineConfig } from '../../config';

export function toastGenerationStoppedAndRestored(): void {
  getNoteGenerationEngineConfig().reactions.toastGenerationStoppedAndRestored();
}

export function toastGenerationStopped(): void {
  getNoteGenerationEngineConfig().reactions.toastGenerationStopped();
}

export function toastSectionalConversionFailed(): void {
  getNoteGenerationEngineConfig().reactions.toastSectionalConversionFailed();
}

/**
 * Pre-redesign toast for an unavailable template, one per code. Used with the
 * pro-actions flag OFF, and for Haiku either way (it mounts no picker).
 * Pre-formatted strings, not `FormattedMessage` elements, so toast error
 * tracking can extract an identifiable message.
 */
export function toastUnavailableTemplate(code: string): void {
  getNoteGenerationEngineConfig().reactions.toastUnavailableTemplate(code);
}
